import { AxiosInstance } from "axios";
import TokenHelper from "../utils/tokenHelper";

export const collectionSubjectType = "collection";

export const basePath = "/collections";
// All the paths for this api domain.
export const collectionPaths = {
  toggleCollectionLike: () => "/luvit",
};

class CollectionApi {
  api: AxiosInstance;
  tokenHelper: TokenHelper;

  constructor(api: AxiosInstance, tokenHelper: TokenHelper) {
    this.api = api;
    this.tokenHelper = tokenHelper;
  }

  // Toggle collection like.
  // POST /luvit
  toggleCollectionLike = (collectionId: number) => {
    const token = this.tokenHelper.getRefreshToken();
    return this.api.post(
      collectionPaths.toggleCollectionLike(),
      {
        subjectType: collectionSubjectType,
        subjectId: collectionId,
      },
      {
        headers: {
          Authorization: this.tokenHelper.formatAuthHeader(token),
        },
      }
    );
  };
}

export default CollectionApi;
